module.exports = __webpack_public_path__ + "img/mistakesText10.6829dad1.png";